module.exports = __webpack_public_path__ + "img/t1-i3.fe2ae0c0.jpg";